var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"daily"},[_c('div',{staticClass:"dailyStatus2"}),_c('div',{staticClass:"dailyStatus"},[_c('div',{staticClass:"icon"}),_c('div',{staticClass:"datetime"},[_vm._v(_vm._s(_vm.toDate(_vm.date))),_c('br'),_vm._v("星期"+_vm._s(_vm.wdy[_vm.moment(_vm.date).weekday()]))]),_c('div',{staticClass:"box"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }